import { FC, useCallback } from "react";
import { Translations } from "../../../utils/translations";
import { getTranslationModule } from "../../../utils/translations";
import Button from "../button";
import useAnalytics from "@/analytics/useAnalytics";

interface IClickToCallButton {
  phone: string;
  isSmartphone: boolean;
  translations: Translations;
}

const ClickToCallButton: FC<IClickToCallButton> = ({ phone, isSmartphone, translations }) => {
  const { sendAnalyticsEvent } = useAnalytics();
  const t = getTranslationModule(translations, "common");
  const title = t("click_to_call");

  const clickHandler = useCallback(() => {
    sendAnalyticsEvent("asc_click_to_call", {
      comm_phone_number: phone,
      department: "sales",
    });
    window.open(`tel:${phone}`, "_self");
  }, [phone, sendAnalyticsEvent]);

  return isSmartphone ? <Button aria-label={title} onClick={clickHandler} text={title} /> : null;
};

export default ClickToCallButton;
